import type { StorageCategory } from '../../config/types/rules'
import { getEnvironment } from '../utils/environment'

export type TrackPayload = {
  consents: {
    storage: StorageCategory[]
  }
  consentTime: string // ISO date string
  user: {
    consentUUID: string
    firstConsented: string // ISO date string
  }
}

function getBaseURL() {
  const environment = getEnvironment(window.location.hostname)

  const targetEnvironment = environment === 'local' ? 'staging' : environment
  const topLevelDomain = environment === 'production' ? 'co.uk' : 'info'

  return `https://${targetEnvironment}-api.gousto.${topLevelDomain}`
}

function createTrackPayload(storedConsent: SavedCookieContent): TrackPayload {
  return {
    consents: {
      storage: storedConsent.categories as StorageCategory[],
    },
    consentTime: storedConsent.last_consent_update,
    user: {
      consentUUID: storedConsent.consent_uuid,
      firstConsented: storedConsent.consent_date,
    },
  }
}

export async function trackConsent(storedConsent: SavedCookieContent) {
  const URL = `${getBaseURL()}/consentlogging/track`

  try {
    const result = await fetch(URL, {
      method: 'POST',
      body: JSON.stringify(createTrackPayload(storedConsent)),
    })

    if (result.status > 499)
      throw new Error(
        `Tracking storage consent failed with status ${result.status}`,
      )
  } catch (err) {
    //! TODO - consistent error logging/handling
    console.error(err)

    return { success: false }
  }

  return { success: true }
}
